import { BreadcrumbView } from "../components/BreadCrumb";
import { Heading } from "../components/common/Heading";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";

interface ToolsLayoutProps {
  children: React.ReactNode;
}

export const ToolsLayout: React.FC<ToolsLayoutProps> = ({ children }) => {
  return (
    <>
      <Navbar />
      <div className="mx-auto flex w-full items-start justify-start px-4 py-10 text-start md:px-8">
        <BreadcrumbView />
      </div>

      {children}
      <Footer />
    </>
  );
};
